import { isCorrectResponse } from '../../guards/isCorrectAiResponse';
import { AIResponse } from '../../types';

export const parseAiResponseFromMessage = (
  content?: string | null
): AIResponse | null => {
  try {
    const parsedContent = JSON.parse(content || '');

    if (!isCorrectResponse(parsedContent)) return null;

    return parsedContent;
  } catch {
    return null;
  }
};
